import React, { useState } from 'react';
import Navigation from "../components/Navigation/Navigation";
import FrontendFooter from "../components/Layout/FrontendFooter";
import { Card, CardContent, Container, Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AboutBanner from "../assets/images/leadership.jpg";
import Rameela from "../assets/images/rameela.png";
import NoImage from "../assets/images/no-image.jpg";

const Leadership = () => {
  const leaders = [
    {
      id: 1,
      name: 'Vijay M Lal',
      bio: ' ',
      image: NoImage
    },
    {
      id: 2,
      name: 'Vijay Reddy',
      bio: ' ',
      image: NoImage
    },
    {
      id: 3,
      name: 'B. Rameela',
      bio: 'Ms. Rameela is the Director of Vizag Profiles Logistics Pvt. Ltd., where she leads finance operations for the Logistics and Transport division of the Vizag Profiles Group. With a strong educational background in finance and international business, she is skilled in finance and budgeting. At v-hub, she manages budgeting, financial planning, and asset management to drive sustainable growth and fiscal discipline, helping the hub’s mission to build a strong and successful innovation ecosystem.',
      image: Rameela
    },
  ];

  const [flippedCard, setFlippedCard] = useState(null);

  const handleCardHover = (id) => {
    setFlippedCard(id);
  };

  const handleCardLeave = () => {
    setFlippedCard(null);
  };

  return (
    <div className="fp-wrapper app-container">
      <Navigation />

      <section className="inner-banner text-white" style={{ backgroundImage: `url(${AboutBanner})` }}>
        <div className="home-container">
          <h1 className="page-title">Leadership</h1>
          <p>Our leadership team brings together decades of experience and expertise in the steel industry.</p>
        </div>
      </section>

      <section className="about-section inner-page-content">
        <Container maxWidth="lg">
          <Box>
            {leaders.map((leader, index) => (
              <Card
                key={leader.id}
                style={{
                  width: '100%',
                  marginBottom: '20px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid #ddd'
                }}
                onMouseEnter={() => handleCardHover(leader.id)}
                onMouseLeave={handleCardLeave}
              >
                <CardContent>
                  <Grid
                    container
                    spacing={4}
                    justifyContent="space-between"
                    alignItems="center"
                    direction={index % 2 === 0 ? 'row' : 'row-reverse'} // Alternate layout
                  >
                    <Grid size={{ xs: 12, md: 4 }} className="leader-block1">
                      <img
                        src={leader.image}
                        alt={leader.name}
                        className="card-image"
                        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }} className="leader-block2">
                      <Typography
                        variant="h4"
                        component="h4"
                        className="block-title"
                      >
                        {leader.name}
                      </Typography>
                      <Typography variant="body1" component="p">
                        {leader.bio && leader.bio}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default Leadership;